import { api } from '..';

import {
  ViewReceiverListResponseType,
  ViewReceiverParams,
  ViewReceiverResponseType,
  AddReceiverParams,
  AddReceiverResponseType,
  EditReceiverParams,
  EditReceiverResponseType,
  DeleteReceiverParams,
  DeleteReceiverResponseType
} from './types';

import {
  viewReceiverList,
  viewReceiver,
  addReceiver,
  editReceiver,
  deleteReceiver
} from './constants';

export const fetchViewReceiverList = async () => {
  return await api
    .get<ViewReceiverListResponseType>(viewReceiverList)
    .then((res) => {
      return Promise.resolve(res);
    })
    .catch((err) => {
      return Promise.reject(err.response.data);
    });
}

export const fetchViewReceiver = async (params: ViewReceiverParams) => {
  const { id } = params;

  return await api
    .get<ViewReceiverResponseType>(`${viewReceiver}/${id}`)
    .then((res) => {
      return Promise.resolve(res);
    })
    .catch((err) => {
      return Promise.reject(err.response.data);
    });
}

export const fetchAddReceiver = async (params: AddReceiverParams) => {
  return await api
    .post<AddReceiverResponseType>(addReceiver, JSON.stringify(params))
    .then((res) => {
      return Promise.resolve(res);
    })
    .catch((err) => {
      return Promise.reject({ ...err.response.data, status: err.response.status });
    });
}

export const fetchEditReceiver = async (id: string, params: EditReceiverParams) => {
  return await api
    .put<EditReceiverResponseType>(`${editReceiver}/${id}`, JSON.stringify(params))
    .then((res) => {
      return Promise.resolve(res);
    })
    .catch((err) => {
      return Promise.reject({ ...err.response.data, status: err.response.status });
    });
}

export const fetchDeleteReceiver = async (params: DeleteReceiverParams) => {
  const { id } = params;

  return await api
    .delete<DeleteReceiverResponseType>(`${deleteReceiver}/${id}`)
    .then((res) => {
      return Promise.resolve(res);
    })
    .catch((err) => {
      return Promise.reject({ ...err.response.data, status: err.response.status });
    });
}